module.exports = __webpack_public_path__ + "static/media/landing_insights_1.1df6d0ce.png";